<template>
  <div class="column is-8">
    <h4 class="is-size-4-desktop">{{ title }}</h4>
    <h4 v-if="bodega" class="is-size-6-desktop">
      Sucursal: {{ bodega.sucursal.nombre }} - {{ bodega.nombre }}
    </h4>
    <div v-else class="notification is-info">
      El usuario identificado no se encuentra asignado a una sucursal y/o
      bodega. Favor contactar al administrador.
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega'])
  }
}
</script>
